import React from "react";

import "./input.scss";

const Input = props => (<input {...props} className="styled-input" />);

export default Input;